// SignIn.js
import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

// import AppTheme from '../shared-theme/AppTheme';
// import ColorModeSelect from '../shared-theme/ColorModeSelect';

import authenticationService from '../Utilities/authenticationService';

import { useSelector, useDispatch } from 'react-redux';

// import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

export default function SignIn(props) { 

  const { reset4All, setCredential, setUsernameErrorMessage, setPasswordErrorMessage, setUsername, setPassword, setPasswordError, setUsernameError, setSupervisorList, setManagerList, setAssignList, setServiceList, setMemberList } = reducer;
  const { FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, Search, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem, SystemConfig } = component;  
  const { postLogListItem, deleteVerseReadLogListItem, postVerseReadLogListItem, postHistoryListItem, getHasNoteVerses, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, chapter4SetVerseReadLogList, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();
  
  const navigate = useNavigate();
  
  const dispatch = useDispatch(); // dispatch(
//   const usernameErrorMessage = useSelector((state) => state.signIn.usernameErrorMessage);
//   const passwordErrorMessage = useSelector((state) => state.signIn.passwordErrorMessage);
  const username = useSelector((state) => state.signIn.username);
  const password = useSelector((state) => state.signIn.password);
//   const passwordError = useSelector((state) => state.signIn.passwordError);
//   const usernameError = useSelector((state) => state.signIn.usernameError);
//   const loading4SignIn = useSelector((state) => state.signIn.loading4SignIn);
  const credential = useSelector((state) => state.signIn.credential);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username && password) {
      authenticationService
      .signin(username, password)
      .then((token) => {
        if (token.length > 0) {
          dispatch(reset4All());
          const credential = {
            UserName: username,
            Token: token
          };
          dispatch(setCredential(credential));
          navigate('/home');
        } else {

        }
      })
    }
  };

  const validateInputs = (e) => {
    handleSubmit(e);
    dispatch(setUsernameError(false));
    dispatch(setPasswordError(false));

  };

  const onChangeUsername = (e) => {
    dispatch(setUsername(e.target.value));
  }  

  useEffect(() => {
    //dispatch(reset4All());
  }, []);

  return (

    <div style={{ paddingTop: '100px', paddingLeft: '25px', paddingRight: '25px' }}>

      <Card>

        <InputText id="name" value={username} className="p-d-block" placeholder="Enter username" onChange={onChangeUsername} />              
        <InputText id="name" value={password} type="password" className="p-d-block" placeholder="Enter password" onChange={e => dispatch(setPassword(e.target.value))} />              
        
        <Button
          type="submit"
          fullWidth
          variant="contained"
          onClick={validateInputs}
        >
          登入
        </Button>


      </Card>

    </div>

  );

}